/**
 * Centralized Lodash Utilities
 *
 * This file provides a centralized import point for all commonly used lodash functions.
 * It organizes functions by category for better maintainability and reduces the number
 * of individual imports needed across the codebase.
 *
 * @author Housefolios
 * @created 2025-01-27
 * @modified 2025-08-12
 */

// Array utilities
export {
  map,
  filter,
  find,
  findIndex,
  head,
  last,
  slice,
  concat,
  compact,
  uniq,
  uniqBy,
  uniqWith,
  intersection,
  intersectionBy,
  difference,
  pull,
  pullAt,
  pullAll,
  pullAllBy,
  remove,
  chunk,
  flatten,
  flatMap,
  zip,
  unzip,
  union,
  fill,
  drop,
  groupBy,
} from 'lodash'

// Object utilities
export {
  get,
  set,
  unset,
  merge,
  clone,
  cloneDeep,
  assign,
  keys,
  has,
  isEqual,
  isEqualWith,
  matchesProperty,
  omitBy,
} from 'lodash'

// String utilities
export {
  toLower,
  toUpper,
  trim,
  replace,
  split,
  join,
  padStart,
  truncate,
  startCase,
  kebabCase,
  capitalize,
  upperFirst,
  startsWith,
  toString,
} from 'lodash'

// Number utilities
export {
  sum,
  sumBy,
  mean,
  meanBy,
  max,
  maxBy,
  min,
  minBy,
  round,
  ceil,
  floor,
  isNaN,
} from 'lodash'

// Type checking utilities
export {
  isNil,
  isUndefined,
  isNull,
  isString,
  isArray,
  isObject,
  isNumber,
  isEmpty,
  every,
  some,
} from 'lodash'

// Collection utilities
export {
  forEach,
  reduce,
  sortBy,
  orderBy,
  includes,
  indexOf,
  lastIndexOf,
  findKey,
} from 'lodash'

// Function utilities
export { debounce, throttle } from 'lodash'

// Chain utilities
export { chain } from 'lodash'
